import { getPageSize } from "../../../selectors";

const getNextPageNumber = state =>
  Math.floor((state.offset.upper + 1) / getPageSize(state)) + 1;

export default getNextPageNumber;
